import { axios } from "@/utils/request";

const device_api = {
  devices: "/api/wechat/devices/",
  books: "/api/wechat/books/",
};

// export default api

export function getDevices(parameter) {
  return axios({
    url: device_api.devices,
    method: "get",
    params: parameter,
  });
}

export function getDeviceBooks(parameter) {
  return axios({
    url: device_api.books,
    method: "get",
    params: parameter,
  });
}
